import React, { useEffect, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/Icon'

import './YandexDeliveryWidget.scss'

const YandexMapModal = ({ onClose }) => {
  const iframeRef = useRef(null)
  const currentOrigin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : process.env.server.WEBSITE_URL
  const allowedOrigins = Array.from(
    new Set([currentOrigin, process.env.server.WEBSITE_URL, 'null'].filter(Boolean)),
  )
  const targetOrigin = currentOrigin || process.env.server.WEBSITE_URL
  const widgetDocument = useMemo(
    () => `
      <!DOCTYPE html>
      <html lang='ru'>
        <head>
          <meta charset='UTF-8'>
          <meta name='viewport' content='width=device-width, initial-scale=1'>
          <style>
            html, body { margin: 0; padding: 0; height: 100%; overflow: hidden; }
            #delivery-widget { width: 100%; height: 100%; }
          </style>
          <script src='https://ndd-widget.landpro.site/widget.js' async></script>
        </head>
        <body>
          <div id='delivery-widget'></div>
          <script>
            function startWidget() {
              if (!window.YaDelivery) return

              window.YaDelivery.createWidget({
                containerId: 'delivery-widget',
                params: {
                  city: 'Москва',
                  size: {
                    height: '660px',
                    width: '100%'
                  },
                  source_platform_station: '39e9b22f-f893-41be-8ea1-60baf03a5dde',
                  physical_dims_weight_gross: 200,
                  delivery_price: '',
                  delivery_term: 1,
                  show_select_button: true,
                  filter: {
                    type: ['pickup_point', 'terminal'],
                    is_yandex_branded: false,
                    payment_methods_filter: 'or',
                    payment_methods: ['already_paid']
                  }
                },
              })

              document.addEventListener('YaNddWidgetPointSelected', function (event) {
                if (!event.detail) return

                window.parent.postMessage(
                  {
                    type: 'YA_DELIVERY_ADDRESS',
                    payload: event.detail
                  },
                  '${targetOrigin}'
                )
              })
            }

            if (window.YaDelivery) {
              startWidget()
            } else {
              document.addEventListener('YaNddWidgetLoad', startWidget)
            }
          </script>
        </body>
      </html>
    `,
    [targetOrigin],
  )

  useEffect(() => {
    const handleMessage = (event) => {
      if (!allowedOrigins.includes(event.origin)) {
        return
      }
      
      if (iframeRef.current && event.source !== iframeRef.current.contentWindow) {
        return
      }

      if (!event.data || typeof event.data !== 'object') return

      if (event.data.type !== 'YA_DELIVERY_ADDRESS') return

      const { type, payload } = event.data

      const isValidAddress = (data) => {
        return data && 
          data.id && 
          data.address
      }

      if (type === 'YA_DELIVERY_ADDRESS' && isValidAddress(payload)) {
        onClose(payload)
      }

    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [allowedOrigins, onClose, targetOrigin])

  return (
    <div
      className='wrapper-widget'
      onClick={() => onClose()}
      >
      <div
        className='container-widget'
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => onClose()}
          className='btn-widget'
        >
          <Icon id='btn_close' color="white"/>
        </button>

        <iframe
          ref={iframeRef}
          title='Yandex Delivery Widget'
          className='iframe-widget'
          srcDoc={widgetDocument}
          sandbox="allow-scripts allow-same-origin"
          allow="geolocation"
          allowFullScreen={false}
        />
      </div>
    </div>
  )
}

YandexMapModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default YandexMapModal
